<template>
  <div class="background">
    <div class="menu">
      <div>
        <img style="width: 173px;height: 36px;" src="@/assets/images/shandian_logo.png">
      </div>
      <el-menu router default-active="/" :ellipsis="false" mode="horizontal" @select="toTop">
        <el-menu-item index="/">雷电加速器首页</el-menu-item>
        <el-sub-menu index="/about">
          <template #title>雷电加速器下载</template>
          <el-menu-item class="subdownload">
            <div class="gird22">
              <el-button @click="handleDownload(3)">
                <img class="icon" src="@/assets/images/win_sel.png">
                Windows下载
              </el-button>
              <el-button @click="handleDownload(1)">
                <img class="icon" src="@/assets/images/android_sel.png">
                Android下载
              </el-button>
              <!-- <el-button @click="handleDownload(2)">
                <img class="icon" src="@/assets/images/apple_sel.png">
                iOS下载
              </el-button> -->
              <!-- <el-button @click="handleDownload(4)">
                <img class="icon" src="@/assets/images/macos_sel.png">
                MacOS下载
              </el-button> -->
            </div>
          </el-menu-item>
        </el-sub-menu>
        <el-menu-item index="/help">问题帮助</el-menu-item>
        <el-menu-item index="/about">关于我们</el-menu-item>
      </el-menu>
    </div>
  </div>
  <router-view />
  <div class="downloadnow">
    <div class="nowuse">即刻使用，安全、极速、稳定畅游全球</div>
    <div class="todown" @click="todown">雷电加速器下载</div>
    <div class="tag" />
  </div>
  <div class="footer">
    <el-row>
      <el-col :span="8">软件名称：雷电加速器</el-col>
      <el-col :span="8">版本号：{{ version }}</el-col>
      <el-col :span="8">
        <el-button link @click="jumpUser">《用户协议》</el-button>与<el-button style="margin: 0;" link @click="jumpPirv">
          《隐私协议》
        </el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8">公司名称：杭州土洲科技有限公司</el-col>
      <el-col :span="8">开发者名称：杭州土洲科技有限公司</el-col>
      <el-col :span="8" />
    </el-row>
    <el-row>
      <el-col :span="8"><el-button link @click="jumpBeian">浙ICP备2021003980号-8A</el-button></el-col>
      <el-col :span="8">地址：浙江省杭州市富阳区银湖街道富闲路666号1号楼904室</el-col>
      <el-col :span="8" />
    </el-row>
  </div>
  <el-dialog v-model="dl.show">
    <div class="captcha_dialog">
      <img class="img" :src="dl.src" alt="" @click="changeCaptcha">
      <div class="text">看不清？<span class="changeCaptcha" @click="changeCaptcha">换一张</span></div>
      <el-input v-model="dl.code" class="input" size="small" placeholder="请输入图形中的验证码" />
      <el-button
        style="width: 294px;" type="primary" @click="confirmDownload"
        @keyup.enter="confirmDownload">
        确认下载
      </el-button>
    </div>
    <template #title>
      <span style="color: #333333;">完成字符验证即可下载</span>
    </template>
  </el-dialog>
</template>
<script lang="ts" setup>
import {
  ref, onMounted, reactive, onUnmounted,
} from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import axios from 'axios'
import { useStore } from '@/store/index'

let router = useRouter()

const vuex = useStore()
vuex.getOptionList()
onMounted(() => {
  if (localStorage.getItem('lsspeedtoken')) {
    vuex.$state.isLogin = true
    vuex.$state.name = localStorage.getItem('lsspeedname') || ''
  }
})
const version = ref('1.0.0')
const dl: any = reactive({
  show: false,
  type: 0,
  src: '',
  code: '',
  token: '',
})

// vuex.getOptionList()
const jumpBeian = () => {
  window.location.href = 'https://beian.miit.gov.cn/#/Integrated/index'
}
const jumpUser = () => {
  window.open('https://leidianshare.mianzhikeji.com/index.html#/thunder/lduser')
}
const jumpPirv = () => {
  window.open('https://leidianshare.mianzhikeji.com/index.html#/thunder/ldprivacy')
}
const download = (url: string) => {
  // 安装包在跨域 OSS 上。带 download 属性时，浏览器会按 CORS 拉取并重命名；
  // 安卓包响应带了 Access-Control-Allow-Origin，这条路径会静默失败。
  // 不设置 download，交给浏览器按文件类型直接下载。
  const a = document.createElement('a')
  a.style.display = 'none'
  a.href = url
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
const handleDownload = async (val: number) => {
  dl.type = val
  dl.code = ''
  axios.get(`${import.meta.env?.ENV_BASE_API}sp-version-manage/captcha?t=${Date.now()}`, { responseType: 'blob' }).then((res) => {
    dl.token = res.headers['x-captcha-token']
    dl.src = URL.createObjectURL(res.request.response)
  })
  // dl.src = `${import.meta.env?.ENV_BASE_API}sp-version-manage/captcha?t=${Date.now()}`
  dl.show = true
}
const changeCaptcha = async () => {
  // dl.src = `${import.meta.env?.ENV_BASE_API}sp-version-manage/captcha?t=${Date.now()}`
  axios.get(`${import.meta.env?.ENV_BASE_API}sp-version-manage/captcha?t=${Date.now()}`, { responseType: 'blob' }).then((res) => {
    dl.token = res.headers['x-captcha-token']
    dl.src = URL.createObjectURL(res.request.response)
  })
}
const confirmDownload = async () => {
  if (!dl.show) return
  if (!dl.code) {
    ElMessage.error('请输入验证码！')
    return
  }
  try {
    const res = await axios.post(`${import.meta.env?.ENV_BASE_API}sp-version-manage/captcha/verify?code=${dl.code}`, {}, { headers: { 'x-captcha-token': dl.token } })
    if (res.data.code !== 200) {
      ElMessage.error(res.data.msg || '验证码错误！')
      return
    }
    const item = vuex.$state.versionList.find((e) =>
      Number(e.plantForm) === dl.type && e.downloadLink)
    if (!item?.downloadLink) {
      ElMessage.error('暂无该版本下载地址')
      return
    }
    if ([2, 4].includes(dl.type)) window.open(item.downloadLink)
    else {
      download(item.downloadLink)
      ElMessage.success('已开始下载！')
    }
    dl.show = false
  } catch {
    ElMessage.error('下载失败，请稍后重试')
  }
}
const keyDown = (e: { keyCode: number }) => {
  if (e.keyCode === 13 || e.keyCode === 100) {
    confirmDownload()
  }
}
onMounted(() => {
  document.addEventListener('keydown', keyDown)
})
onUnmounted(() => {
  document.removeEventListener('keydown', keyDown, false)
})
const toTop = () => {
  const main = document.getElementById('app')
  if (main) { main.scrollTop = 0 }
}
const todown = () => {
  const main = document.getElementById('app')
  if (main) { main.scrollTop = 0 }
  // document.getElementById('app').scrollTop = 0
  router.push('/')
}
</script>
<style lang="less" scoped>
.background {
  height: 100%;
  margin-bottom: calc(98px - 100vh);
  background: url('@/assets/images/bg.png') 0 0/cover no-repeat;

  .menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 100px;
    font-size: 16px;
    position: fixed;
    top: 0;
    width: 100%;
    background-color: #1F2322;
    z-index: 1;
    /* 走 Element Plus 变量，避免生产环境 vendor CSS 后加载把 background-color 盖回去 */
    --el-menu-bg-color: transparent;
    --el-menu-hover-bg-color: transparent;
    --el-menu-text-color: #fff;
    --el-menu-hover-text-color: #fff;
    --el-menu-active-color: #fff;
    --el-menu-border-color: transparent;
  }
}

.icon {
  width: 28px;
  height: 28px;
  margin-right: 16px;
}

.login {
  padding: 9px 31px;
}

.downloadnow {
  width: 100%;
  height: 256px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: url('@/assets/images/downbg.png') 0 0/cover no-repeat;

  >.nowuse {
    font-size: 44px;
    color: #FFFFFF;
    line-height: 62px;
    margin-bottom: 32px;
    z-index: 1;
  }

  >.todown {
    cursor: pointer;
    font-size: 20px;
    color: #FFFFFF;
    padding: 12px 60px;
    line-height: 28px;
    border-radius: 8px;
    border: 1px solid #FFFFFF;
  }

  >.tag {
    width: 452px;
    height: 323px;
    position: absolute;
    left: 79px;
    bottom: 9px;
    background: url('@/assets/images/shandian.png') 0 0/cover no-repeat;
  }
}

.footer {
  width: 100%;
  height: 272px;
  padding: 68px;
  color: #fff;
  font-size: 14px;
  line-height: 38px;
}
</style>
<style lang="less">
.el-menu-item {
  font-size: 16px
}

.el-menu--horizontal,
.el-menu--horizontal>.el-menu-item,
.el-menu--horizontal>.el-menu-item.is-active {
  border: none;
  color: #fff !important;
}

.el-popper.is-pure {
  height: auto;
  background-color: #fff;
  border: none;
}

.subdownload {
  height: 180px !important;
  --el-text-color-primary: #333333;
  --el-text-color-regular: #333333;
}

.gird22 {
  display: grid;
  grid-template-columns: 200px 200px;
  grid-template-rows: 52px 52px;
  gap: 20px;
  margin: 20px;

  >.el-button {
    width: 200px;
    padding: 15px 35px;
    font-size: 16px;
    line-height: 22px;
    height: auto;
    margin: 0;
  }
}

.menu .el-menu {
  --el-menu-bg-color: transparent;
  background-color: transparent;
}

.el-menu--horizontal>.el-menu-item,
.el-menu--horizontal>.el-sub-menu .el-sub-menu__title {
  font-size: 16px;
  color: #fff;
}

.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal>.el-sub-menu:hover .el-sub-menu__title,
.el-menu--horizontal>.el-menu-item.is-active {
  background-color: transparent;
  color: #fff;

  &::after {
    left: calc(50% - 16px);
    bottom: 4px;
    content: '';
    width: 32px;
    height: 8px;
    background: url('@/assets/images/image／menu_active.png') 0 0/cover no-repeat;
    position: absolute;
  }
}

.captcha_dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 153px 24px 153px;
  --el-text-color-regular: #333333;

  .img {
    cursor: pointer;
    width: 212px;
    height: 86px;
  }

  .text {
    margin-top: 16px;
    font-size: 16px;
    color: #666666;
    line-height: 22px;

    .changeCaptcha {
      cursor: pointer;
      color: #2E8AFF;
    }
  }

  .input {
    margin: 24px 0;
    width: 212px;
    height: 36px;
  }
}

#chatBtn {
  img {
    width: 25px;
    height: 25px;
    display: inline;
  }
}
</style>
<style>
.el-menu--horizontal.el-menu {
  border-bottom: none;
}
</style>
